import React from "react"
import {useTranslation} from "react-i18next"

import {IonButton, IonIcon, useIonAlert} from "@ionic/react"
import {lockClosedOutline, lockClosedSharp} from "ionicons/icons"
import {useHistory} from "react-router";
import TimeLimit from "@customTypes/TimeLimit";

interface props {
    timeLimit: TimeLimit
}

const ListItemButtonLockTimeLimit: React.FC<props> = ({ timeLimit }) => {

    const {t} = useTranslation()
        , history = useHistory()
        , [presentAlert] = useIonAlert()
        , lockTimeLimitsCount: number = timeLimit.lockTimeLimits?.length || 0
        , translationKey: string = "time-limits.alerts." + (lockTimeLimitsCount ? 'locks' : 'no_locks')

    const alertMessage = async (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        return presentAlert({
            header:  t(translationKey + '.header'),
            message: t(translationKey + '.message'),
            buttons: [{
                text: t('common.cancel'),
                role: 'cancel'
            }]
        })
    }

    const goToTimeLimitLocks = (ev: any) => {
        ev.preventDefault()
        ev.stopPropagation()

        if (timeLimit.keyTimeLimits) {
            return history.push('/time-limits/' + timeLimit.id + '/locks')
        }

        alertMessage(ev).then()
    }

    return (
        <IonButton color={lockTimeLimitsCount > 0 ? "medium" : "light"} fill="clear"
                   onClick={ (ev) => goToTimeLimitLocks(ev) }
                   shape="round" size="large" style={{ 'fontSize': '1rem' }}>
            <IonIcon slot="start" ios={lockClosedOutline} md={lockClosedSharp} />
            {lockTimeLimitsCount || '-'}
        </IonButton>
    )
}

export default ListItemButtonLockTimeLimit